export enum StandardDetailGenerationStatus {
  NotGenerated = 0,
  Generated = 1,
  GenerationError = 2,
  Generating = 3,
}

export enum SaveStandardDetailDifyRequestFlag {
  Save = 0,
  SaveAndGenerate = 1,
}

export enum SaveStandardDetailIsUpdateCorrectionTemplate {
  False = 0,
  True = 1,
}
